import { render, staticRenderFns } from "./Edit_new_template.vue?vue&type=template&id=687a4ace"
import script from "./Edit_new_template.vue?vue&type=script&lang=js"
export * from "./Edit_new_template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports